

<template>
    <div style="background-color: #0e39bd;height: 100%">

    <div id="table-box">
        <van-row justify="center">
            <!--            <van-col span="6">-->
            <van-image
                width="100%"
                height="100%"
                src="https://afa.activa-leisure.com/img/fkdj.jpg"
            />
            <!--            </van-col>-->
        </van-row>
        <van-col span="20"></van-col>

        <van-form @submit="onSubmit">
            <van-cell-group inset>
            <van-field
                v-model="fwqy"
                is-link
                readonly
                label="访问区域"
                placeholder="选择区域"
                @click="showFwqy = true"
            />
            <van-popup v-model:show="showFwqy" round position="bottom">
                <van-picker
                    :columns="fwqyColumns"
                    @cancel="showFwqy = false"
                    @confirm="onConfirmFwqy"
                />
            </van-popup>
                <van-field
                    v-model="name"
                    label="访客姓名"
                    placeholder="请填写访客姓名"
                    required
                    :rules="[{ required: true, message: '请填写访客姓名' }]"
                />
                <van-field
                    v-model="tel"
                    type="number"
                    required
                    label="访客电话"
                    placeholder="请填写访客电话"
                    maxlength="11"
                    :rules="[{ required: true, message: '请填写访客电话', trigger: 'blur' },{ pattern: /^\d{11}$/, message: '手机号必须是11位数字', trigger: 'blur' }]"
                />
                <van-field
                    v-model="idNo"
                    label="身份证号"
                    placeholder="请填写访客身份证号"
                    maxlength="18"
                />
                <van-field
                    v-model="sum"
                    label="随行人数"
                    type="number"
                    placeholder="请填写随行人数"
                />
                <van-field
                    v-model="date"
                    label="预约时间"
                    placeholder="请填写预约时间"
                    readonly
                    required
                    @click="showChoseDate = true"
                    :rules="[{ required: true, message: '请填写预约时间' }]"
                />
                <van-field
                    v-model="car"
                    label="车辆信息"
                    placeholder="请填写车牌号"
                />
                <van-field
                    type="textarea"
                    required
                    v-model="lfsy"
                    label="来访事由"
                    placeholder="请填写来访事由"
                    :rules="[{ required: true, message: '请填写来访事由', trigger: 'blur' }]"
                />
                <van-field
                    type="textarea"
                    v-model="remark"
                    label="备注"
                    placeholder="随行人员，物品清单等"
                />
                <van-field
                    v-model="jdName"
                    required
                    label="接待人姓名"
                    placeholder="请填写接待人姓名"
                    :rules="[{ required: true, message: '请填写接待人姓名', trigger: 'blur' }]"
                />
                <van-field
                    v-model="jdTel"
                    type="number"
                    required
                    label="接待人电话"
                    placeholder="请填写接待人电话"
                    :rules="[{ required: true, message: '请填写接待人电话', trigger: 'blur' },{ pattern: /^\d{11}$/, message: '手机号必须是11位数字', trigger: 'blur' }]"
                />
                <van-field
                    v-model="jdDept"
                    required
                    label="接待人部门"
                    placeholder="请填写接待人部门"
                    :rules="[{ required: true, message: '请填写接待人部门', trigger: 'blur' }]"
                />

            </van-cell-group>
            <div style="margin: 16px;" >
                <van-button round block type="success" native-type="submit" style="font-size: larger">
                    提&nbsp;&nbsp;交
                </van-button>
            </div>
            <div style="margin: 16px;height: 10px" ></div>


            <van-popup  v-model:show="showChoseDate" round position="bottom">

            <van-picker-group
                title="预约日期"
                :tabs="['选择日期', '选择时间']"
                next-step-text="下一步"
                @confirm="onDateConfirm"
                @cancel="onDateCancel"
            >
                <van-date-picker
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                />
                <van-time-picker v-model="currentTime" />
            </van-picker-group>
            </van-popup>

            <van-popup  v-model:show="showQrCode">
                <div class="body_qr" style="height: 330px">

                    <vue-qr :text="qrCodeValue" :size="260"
                    ></vue-qr>
                    <p style="height: 10px;margin-top: 0;font-size: 23px; font-weight: bold;">{{xxx}}</p>
                    <p style="color: red">&nbsp;请截图保存至手机，进出园区需出示预约码！</p>
                </div>
            </van-popup>

        </van-form>

    </div>
    </div>
</template>

<script setup>
import {ref,onMounted } from "vue";
/*import axios from "axios";*/
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import axios from "axios";



let fwqyColumns = [
    { text: '一期厂区', value: '1' },
    { text: '二期厂区', value: '2' },
    { text: '行政楼', value: '3' },
    { text: '生活区', value: '4' },
];

const fwqy = ref('一期厂区');
const name = ref('');
const tel = ref('');
const idNo = ref('');
const sum = ref('');
const date = ref('');
const car = ref('');
const lfsy = ref('');
const remark = ref('');
const jdName = ref('');
const jdTel = ref('');
const jdDept = ref('');
const showFwqy = ref(false);

const currentDate = ref(['2022', '06', '01']);
const currentTime = ref(['12', '00']);
const minDate = new Date(2020, 0, 1);
const maxDate = new Date(2099, 1, 1);
const showChoseDate = ref(false);
const showQrCode = ref(false);
const qrCodeValue = ref('');
const xxx = ref('');

const onConfirmFwqy = ({ selectedOptions }) => {
    showFwqy.value = false;
    fwqy.value = selectedOptions[0].text;
};

const onDateConfirm = () => {
    date.value=`${currentDate.value.join('/')} ${currentTime.value.join(':')}`;
    showChoseDate.value=false;
    /*showToast(
        `${currentDate.value.join('/')} ${currentTime.value.join(':')}`,
    );*/
};

const onDateCancel = () => {
    showChoseDate.value=false;
    date.value='';
};

onMounted(() => {
    window.document.title = '宁波万汇访客登记';
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1，并填充前导零
    const day = String(now.getDate()).padStart(2, '0'); // 填充前导零
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    currentDate.value = [year, month, day];
    currentTime.value = [hours,formattedMinutes];
    date.value=`${currentDate.value.join('/')} ${currentTime.value.join(':')}`;

    //判断缓存
    const checkIn_name = localStorage.getItem("checkIn_name");
    if (checkIn_name) {
        name.value = checkIn_name;
    }
    const checkIn_tel = localStorage.getItem("checkIn_tel");
    if (checkIn_tel) {
        tel.value = checkIn_tel;
    }
    const checkIn_jdName = localStorage.getItem("checkIn_jdName");
    if (checkIn_jdName) {
        jdName.value = checkIn_jdName;
    }
    const checkIn_jdTel = localStorage.getItem("checkIn_jdTel");
    if (checkIn_jdTel) {
        jdTel.value = checkIn_jdTel;
    }
    const checkIn_jdDept = localStorage.getItem("checkIn_jdDept");
    if (checkIn_jdDept) {
        jdDept.value = checkIn_jdDept;
    }


})

const onSubmit  = () => {

    //塞缓存
    localStorage.setItem("checkIn_name", name.value);
    localStorage.setItem("checkIn_tel", tel.value);
    localStorage.setItem("checkIn_jdName", jdName.value);
    localStorage.setItem("checkIn_jdTel", jdTel.value);
    localStorage.setItem("checkIn_jdDept", jdDept.value);
    console.log("登录数据已缓存");

    const formData = {
        fwqy:fwqy.value,
        name:name.value,
        tel:tel.value,
        idNo:idNo.value,
        sum:sum.value,
        date:date.value,
        car:car.value,
        lfsy:lfsy.value,
        remark:remark.value,
        jdName:jdName.value,
        jdTel:jdTel.value,
        jdDept:jdDept.value
    }

    axios.post(process.env.VUE_APP_API_BASE_URL + '/lj/fkdj/submit', formData,{
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            console.log('提交成功:', response.data)
            // 在这里可以根据后台返回的数据进行相应的处理
            //alert(response.data.message)
            qrCodeValue.value=process.env.VUE_APP_API_BASE_URL + '/lj/front/CheckInDetail/'+response.data.message;
            xxx.value = '预约时间为：'+date.value.toLocaleString();
            showQrCode.value = true;
        })
        .catch(error => {
            if (error.response) {
                // 请求已经发出，但服务器返回状态码不在2xx范围内
                console.error('返回失败:', error.response.const)
            } else {
                // 请求未能发出
                alert('提交失败:' + error.message)
                console.error('提交失败:', error.message)
            }
        })

}


</script>

<style scoped>


.body_qr {
    text-align: center;
}

</style>
